import { useTheme } from 'styled-components';
import toast, { Toaster, resolveValue } from 'react-hot-toast';

import { Icon } from '@/core/components/Icons';
import { Paragraph } from '@/core/components/Typography';

import {
  ToastCloseButton,
  ToastIconWrapper,
  ToastMessage,
  ToastWrapper,
} from './AppToaster.styles';

export const AppToaster = () => {
  const { colors } = useTheme();

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        removeDelay: 0,
      }}
    >
      {t => {
        const message = resolveValue(t.message, t);
        const isError = t.type === 'error';

        return (
          <ToastWrapper $isError={isError}>
            {isError && (
              <ToastIconWrapper>
                <Icon
                  name="AlertAttentionDangerTriangle"
                  size={20}
                  color={colors.warning}
                />
              </ToastIconWrapper>
            )}
            <ToastMessage>
              <Paragraph
                type="normal"
                color={isError ? colors.warning : colors.primaryText}
              >
                {message}
              </Paragraph>
            </ToastMessage>
            <ToastCloseButton
              type="button"
              onClick={() => toast.dismiss(t.id)}
              aria-label="Close"
            >
              <Icon
                name="Close"
                size={16}
              />
            </ToastCloseButton>
          </ToastWrapper>
        );
      }}
    </Toaster>
  );
};
